import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Your phone number and message
  const phoneNumber = '972559670867'; // Your phone number
  const message = 'שלום. אשמח לקבל מידע נוסף'; // Your desired message

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-4 left-4 z-50 p-3 rounded-full bg-green-500 text-white shadow-lg hover:bg-green-600 transition-all duration-300 transform hover:scale-110 motion-safe:animate-bounce-slow"
        aria-label="Open WhatsApp chat"
      >
        <FaWhatsapp className="w-8 h-8" />
      </button>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="fixed bottom-20 left-4 w-64 bg-white rounded-lg shadow-xl overflow-hidden z-50"
          >
            <div className="p-4 bg-green-500 text-white flex justify-between items-center">
              <span className="font-bold">WhatsApp</span>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white hover:text-gray-200 transition-colors duration-200"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4">
              <p className="text-gray-700 text-sm mb-4">{message}</p>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-block text-center py-2 px-4 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors duration-300"
              >
                פתח צ'אט
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingWhatsApp;
